export default __webpack_public_path__ + "static/media/empty_tickets.9780bcb7.png";